<template>
	<div class="borderBoxShadow">
		<v-row no-gutters>
			<v-col
				cols="2"
				class="text-center"
			>
				<v-icon color="blue darken-2">
					mdi-{{ nearbyPlace.icon }}
				</v-icon>
			</v-col>
			<v-col
				cols="10"
				class="text-left mb-2"
			>
				<h3>{{ nearbyPlace.label }}</h3>
			</v-col>
			<v-col
				cols="12"
				class="detailLists"
			>
				<a
					v-for="(place,i) in nearbyPlace.list.slice(0, placeLimit)"
					:id="nearbyPlace.type + '_' + i"
					:key="nearbyPlace.type + '_' + i"
					v-ripple
					@click="closeInfo(); openInfo(place);"
					@mouseover="openInfo(place)"
					@mouseout="closeInfo"
				>
					<v-row no-gutters>
						<v-col :cols="place.duration && place.distance ? 7 : 12">
							<p>{{ place.name }}</p>
						</v-col>
						<v-col
							v-if="place.duration && place.distance"
							cols="5"
							class="text-right"
						>
							<h5>
								<v-icon>
									mdi-walk
								</v-icon>
								{{ place.duration.text.replace('ชั่วโมง', 'hr').replace('นาที', 'mins') }}
							</h5>
							<h6>{{ place.distance.text.replace('กม.', 'km').replace('ม.', 'm') }}</h6>
						</v-col>
					</v-row>
				</a>
			</v-col>
			<v-col
				v-if="nearbyPlace.list.length > 3 && placeLimit !== 20"
				cols="12"
				class="more-icon"
			>
				<v-btn
					text
					color="error"
					@click="placeLimit = 20"
				>
					<v-icon>mdi-chevron-down</v-icon>
					มี{{ nearbyPlace.label }} อีก {{ nearbyPlace.list.length - 3 }} แห่ง ในบริเวณใกล้เคียง
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>

export default {
	props: {
		places: {
			type: Object,
			required: true
		},
		openInfo: {
			type: Function,
			required: true
		},
		closeInfo: {
			type: Function,
			required: true
		}
	},

	data() {
		return {
			placeLimit: 3,
			nearbyPlace: this.places
		}
	},

	methods: {

	}
}
</script>

<style lang="scss" scoped>
.borderBoxShadow {
	border-radius: 5px; box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); padding: 15px 10px;
	margin-bottom: 15px;
}
.detailLists {
  a { background-color: rgb(245, 245, 245); border-left: 2px solid rgb(165, 165, 165); display: block; margin-bottom: 3px; padding: 5px 10px; text-decoration: none;
		&:hover, &.focused {
			background-color: rgb(230, 230, 230);
		}
	}
  h5 { font-size: 0.9em; font-weight: 400; margin-bottom: 0;
    i { font-size: 0.9em; height: auto; }
  }
  i { height: 100%; vertical-align: middle; }
  p { overflow: hidden; max-height: 44px; margin-bottom: 0; }
}
.more-icon::v-deep {
  .v-btn { color: rgb(179, 0, 0); display: block; height: auto; padding: 5px; text-align: left; white-space: inherit;
    i { margin-right: 5px; }
  }
}
</style>
